import '../main.css'
import '../../App.css'
import { useCallback, useEffect, useRef, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleQuestion, faSortDown, faSortUp } from "@fortawesome/free-solid-svg-icons";
import MessageModal from '../messageModal';
import { X, ShoppingBag, ChevronLeft, ReceiptText, RotateCcw, Trash2, SendHorizontal, Gift } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { changeNum, formatUTCDateTime } from '../common/function';
import { changeAlramModal, changecouponTab, changeShoppingFlag, checkDuplicateLogins, checkSecuretId } from '../../store';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { useActionState } from 'react';
import { SyncLoader } from "react-spinners";
import Coupons_Header from './common/coupons_header';
import FallbackImage from '../common/FallbackImage';
import Coupons_Footer from '../common/coupons_footer';

function Coupons() {
    const { t } = useTranslation();

    const mySkin = useSelector((state) => state.mySkin);
    const JWT = useSelector((state) => state.JWT.value);
    const securetId = useSelector((state) => state.securetId.value);
    const couponTab = useSelector((state) => state.couponTab.value);

    const [validCoupons, setValidCoupons] = useState([]);
    const [usedCoupons, setUsedCoupons] = useState([]);
    const [message, setMessage] = useState("");
    const [listSpinner, setListSpinner] = useState(true)
    const [pageAvailable, setPageAvailable] = useState(1)
    const [pageUsed, setPageUsed] = useState(1)
    const [totalAvailable, setTotalAvailable] = useState(0)
    const [totalUsed, setTotalUsed] = useState(0)

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleSelectCoupon = (coupon) => {
        navigate(`/couponsDetail/${coupon.no}`, {
            state: { coupon },
        });
    };

    const ListAvailableData = async () => {
        try {
            const params = new URLSearchParams();
            params.append("page", pageAvailable.toString());
            params.append("take", "20");
            params.append("coupon_status", "01");

            const response = await axios.post(
                process.env.REACT_APP_API + '/api/exchange-events/coupon/user/list',
                params,
                {
                    headers: {
                        Authorization: `Bearer ${JWT}`,
                    },
                }
            );
            const tmp = response?.data?.data ?? [];
            if (pageAvailable === 1) {
                setValidCoupons(tmp ?? []);
            }
            else {
                setValidCoupons((prev) => [...prev, ...tmp ?? []]);
            }
            setTotalAvailable(response?.data?.total ?? 0)
            setListSpinner(false)
        } catch (error) {
            if (error?.response?.status === 999) {
                dispatch(checkDuplicateLogins(true));
            } else {
                console.error(error);
            }
        }
    };

    const ListUsedData = async () => {
        try {
            const params = new URLSearchParams();
            params.append("page", pageUsed.toString());
            params.append("take", "20");
            params.append("coupon_status", "02");

            const response = await axios.post(
                process.env.REACT_APP_API + '/api/exchange-events/coupon/user/list',
                params,
                {
                    headers: {
                        Authorization: `Bearer ${JWT}`,
                    },
                }
            );
            const tmp = response?.data?.data ?? [];
            if (pageUsed === 1) {
                setUsedCoupons(tmp ?? []);
            }
            else {
                setUsedCoupons((prev) => [...prev, ...tmp ?? []]);
            }
            setTotalUsed(response?.data?.total ?? 0)
            setListSpinner(false)
        } catch (error) {
            if (error?.response?.status === 999) {
                dispatch(checkDuplicateLogins(true));
            } else {
                console.error(error);
            }
        }
    };

    useEffect(() => {
        ListAvailableData();
    }, [pageAvailable]);

    useEffect(() => {
        ListUsedData()
    }, [pageUsed]);

    // 만료일까지 남은 일수 계산 함수 (기존과 동일)
    const formatRemainDays = (expireString) => {
        if (!expireString) return '';
        const [datePart] = expireString.split(' ');
        if (!datePart) return '';

        const [yyyy, mm, dd] = datePart.split('-');
        const expireDate = new Date(
            parseInt(yyyy, 10),
            parseInt(mm, 10) - 1,
            parseInt(dd, 10)
        );

        const now = new Date();
        const diffMs = expireDate - now;
        const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

        if (diffDays < -1) {
            return t('coupons_58');
        }
        return `D-${diffDays + 1}`;
    };

    const [isSpinning, setIsSpinning] = useState(false);
    const [cooldown, setCooldown] = useState(false);

    const handleClick = async () => {
        if (cooldown) {
            setMessage({ "code": 0, "msg": "요청회수 초과입니다." })
            dispatch(changeAlramModal())
            return;
        }

        setIsSpinning(true);
        setCooldown(true);

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API}/api/exchange-events/coupon/user/update-coupon-status`,
                {},
                { headers: { Authorization: `Bearer ${JWT}` } }
            );
            const tmp = response.data;
            console.log(tmp);
            if (tmp.success) {
                ListAvailableData();
                ListUsedData()
                setPageAvailable(1)
                setPageUsed(1)
            }
        } catch (error) {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true));
            } else {
                console.error(error);
            }
        } finally {
            setIsSpinning(false);
            // 10초 후에 다시 클릭 가능하도록
            setTimeout(() => setCooldown(false), 10000);
        }
    };

    const onDelete = async (no) => {
        await axios.post(process.env.REACT_APP_API + '/api/exchange-events/coupon/user/remove', {
            coupon_no: no
        }, {
            headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            // console.log(tmp)
            if (tmp?.success) {
                setMessage({ "code": 0, "msg": tmp?.message ?? "Success" })
                dispatch(changeAlramModal())
                setUsedCoupons(prev =>
                    prev.filter(coupon => coupon.no !== no)
                );
            }
            else {
                setMessage({ "code": 1, "msg": tmp?.message ?? "Fail" })
                dispatch(changeAlramModal())
            }
        }).catch((error) => {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true))
            }
            else {
                console.log(error)
            }
        })
    };

    const handleDelete = (no) => {
        if (window.confirm(t('coupons_4'))) {
            onDelete(no);
        }
    };

    const observerAvailableRef = useRef(null);
    const observerUsedRef = useRef(null);

    useEffect(() => {
        if (couponTab !== 0 || validCoupons.length === 0) return;

        const observer = new IntersectionObserver(([entry]) => {
            // console.log('🔥 valid observer');
            if (entry.isIntersecting && totalAvailable > pageAvailable * 20) {
                setPageAvailable((prev) => prev + 1);
            }
        });

        const target = observerAvailableRef.current;
        if (target) observer.observe(target);

        return () => {
            if (target) observer.unobserve(target);
        };
    }, [couponTab, validCoupons, totalAvailable]); // couponTab 의존성 반드시 필요

    useEffect(() => {
        if (couponTab !== 1 || usedCoupons.length === 0) return;

        const observer = new IntersectionObserver(([entry]) => {
            // console.log('🔥 used observer');
            if (entry.isIntersecting && totalUsed > pageUsed * 20) {
                setPageUsed((prev) => prev + 1);
            }
        });

        const target = observerUsedRef.current;
        if (target) observer.observe(target);

        return () => {
            if (target) observer.unobserve(target);
        };
    }, [couponTab, usedCoupons, totalUsed]);

    return (
        <div
            className="friend"
            style={{
                background: "#fff",
                padding: "0px",
                position: "relative",
                color: "#000"
            }}
        >
            <MessageModal message={message} />
            <div style={{ padding: '0px', paddingBottom: '60px', fontFamily: 'sans-serif' }}>
                <Coupons_Header pageName={t('shopping_3')} text={"shopping_4"} />

                {/* <img
                            src="/newImg/banner.png"
                            style={{
                                position: "absolute",
                                top: "0px",
                                left: "0px",
                                width: "100%",
                                cursor: "pointer"
                            }}
                            onClick={() => window.open('https://t.me/Saypot_Event', '_blank')}
                        /> */}
                <div style={{ padding: "10px 15px" }}>
                    <div
                        className="settings-header"
                        style={{
                            color: "#000",
                            fontSize: "22px",
                            fontWeight: "700",
                            lineHeight: "28px",
                            padding: "20px 0",
                            textAlign: "left",
                            marginBottom: "0"
                        }}
                    >
                        {t('coupons_1_0')}<br />
                        {totalAvailable} {t('coupons_1_1')}
                    </div>
                </div>

                {/* 탭 영역 */}
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0px 20px 15px" }}>
                    <div className="coupons-tab">
                        <div
                            onClick={() => dispatch(changecouponTab(0))}
                            className={`coupons-tab-btn ${couponTab === 0 ? 'active' : ''}`}
                        >
                            {t('coupons_2')} {totalAvailable}
                        </div>
                        <div
                            onClick={() => dispatch(changecouponTab(1))}
                            className={`coupons-tab-btn ${couponTab === 1 ? 'active' : ''}`}
                        >
                            {t('coupons_3')} {totalUsed}
                        </div>
                    </div>
                    <div
                        disabled={isSpinning || cooldown}
                        style={{
                            padding: "7px",
                            // padding: "7px 12px",
                            border: "1px solid #f5f5f5",
                            borderRadius: "30px",
                            background: "#fff",
                            fontSize: '13px',
                            cursor: "pointer",
                            color: "#000",
                            display: "flex",
                            alignItems: "center",
                            cursor: isSpinning || cooldown ? "not-allowed" : "pointer",
                            opacity: isSpinning || cooldown ? 0.5 : 1,
                        }}
                        onClick={isSpinning ? undefined : handleClick}
                    >
                        <RotateCcw
                            className={isSpinning ? 'spin-left' : ''}
                            style={{ width: '15px', height: '15px', fontSize: '15px' }}
                        />
                    </div>
                </div>

                {/* 2열 그리드 */}
                {
                    listSpinner
                        ?
                        <div style={{ marginTop: "100px" }}>
                            <SyncLoader
                                color="#ffbb3f"
                                size={10}
                                cssOverride={{ borderWidth: "4px", marginBottom: "0px" }}
                                speedMultiplier={1}
                            />
                        </div>
                        :
                        couponTab === 0
                            ?
                            validCoupons?.length > 0
                                ?
                                <>
                                    <div className="coupons-grid" style={{ padding: "0 20px 60px" }}>
                                        {validCoupons.map((coupon, idx) => (
                                            <div
                                                key={idx}
                                                className="coupon-item"
                                                onClick={() => handleSelectCoupon(coupon)}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <div
                                                    className={`coupon-image-wrapper ${coupon.uc_pin_status_cd !== '01' ? 'used' : ''
                                                        }`}
                                                    style={{ position: 'relative' }}
                                                >
                                                    {coupon.uc_pin_status_cd === '01' && (
                                                        <div className="d-day-badge">
                                                            {formatRemainDays(coupon.uc_expire_date)}
                                                        </div>
                                                    )}

                                                    <img
                                                        src={coupon?.bc_ci_custom_image_filename ? `${process.env.REACT_APP_IMGAPI}/images/coupons/${coupon.bc_ci_custom_image_filename}` : coupon?.ci_goods_img_big ?? "/newImg/preparing.png"}
                                                        className="coupon-image"
                                                        style={{ border: "1px solid #f9f9f9" }}
                                                    />

                                                    {coupon.uc_pin_status_cd !== '01' && (
                                                        <div
                                                            style={{
                                                                position: 'absolute',
                                                                top: '50%',
                                                                left: '50%',
                                                                transform: "translate(-50%, -50%)"
                                                            }}
                                                        >
                                                            <img
                                                                src={
                                                                    coupon.uc_pin_status_cd === '02'
                                                                        ? '/newImg/complete.png'
                                                                        : coupon.uc_pin_status_cd === '07'
                                                                            ? '/newImg/cancel.png'
                                                                            : coupon.uc_pin_status_cd === '08'
                                                                                ? '/newImg/expiration.png'
                                                                                : '/newImg/unavailable.png'
                                                                }
                                                                alt="used-type"
                                                                style={{ width: '85px' }}
                                                            />
                                                        </div>
                                                    )}
                                                    {coupon.uc_pin_status_cd !== '01' ? (
                                                        <div
                                                            style={{
                                                                position: 'absolute',
                                                                top: '5px',
                                                                right: '5px',
                                                                border: "1px solid #e3e3e3",
                                                                width: "30px",
                                                                height: "30px",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                borderRadius: "5px",
                                                                boxShadow: "0 1px 5px rgba(0, 0, 0, 0.1)",
                                                                background: "#fff"
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleDelete(coupon.no);
                                                            }}
                                                        >
                                                            <Trash2 style={{ width: '22px', height: '22px' }} />
                                                        </div>
                                                    ) : coupon.is_gift == 1 && (
                                                        <div
                                                            style={{
                                                                position: 'absolute',
                                                                top: '5px',
                                                                right: '5px',
                                                                width: "30px",
                                                                height: "30px",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                borderRadius: "5px",
                                                                background: "#fff",
                                                                opacity: "0.7"
                                                            }}
                                                        >
                                                            <Gift style={{ width: '22px', height: '22px' }} />
                                                        </div>
                                                    )}
                                                </div>

                                                <div className="coupon-info">
                                                    <div className="coupon-company table-overflow-hidden">
                                                        {coupon.ci_brand_name}
                                                    </div>
                                                    <div className="coupon-title table-overflow-hidden">
                                                        {coupon.ci_goods_name}
                                                    </div>
                                                    <div className="coupon-from table-overflow-hidden">
                                                        from. {Number(coupon.event_no) > 0 ? t('coupons_48') : coupon.is_gift > 0 ? coupon.purchaser_name : t('coupons_49')}
                                                    </div>
                                                    <div className="coupon-date table-overflow-hidden">
                                                        {formatUTCDateTime(coupon.uc_exchange_time)}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div ref={observerAvailableRef} style={{ height: '1px' }}></div>
                                </>
                                :
                                <div style={{ width: "100%", margin: "30px 0", height: "260px", display:"flex", alignItems:"center", justifyContent:"center", flexDirection:"column" }}>
                                    <img src={`/img/noItem.png`} style={{ width: "150px", margin: "0 auto 10px" }} />
                                    <div style={{ width: "100%", textAlign: "center", fontSize: "18px", fontWeight: "bold", color: "#000", marginBottom: '5px' }}>{t('coupons_22')}</div>
                                    <div style={{ width: "100%", textAlign: "center", fontSize: "12px", fontWeight: "500", color: "gray" }}>{t('coupons_23')}</div>
                                </div>
                            :
                            usedCoupons?.length > 0
                                ?
                                <>
                                    <div className="coupons-grid" style={{ padding: "0 20px 60px" }}>
                                        {usedCoupons.map((coupon, idx) => (
                                            <div
                                                key={idx}
                                                className="coupon-item"
                                                onClick={() => handleSelectCoupon(coupon)}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <div
                                                    className={`coupon-image-wrapper ${coupon.uc_pin_status_cd !== '01' ? 'used' : ''
                                                        }`}
                                                    style={{ position: 'relative' }}
                                                >
                                                    {coupon.uc_pin_status_cd === '01' && (
                                                        <div className="d-day-badge">
                                                            {formatRemainDays(coupon.uc_expire_date)}
                                                        </div>
                                                    )}

                                                    <FallbackImage
                                                        src={coupon?.bc_ci_custom_image_filename ? `${process.env.REACT_APP_IMGAPI}/images/coupons/${coupon.bc_ci_custom_image_filename}` : coupon?.ci_goods_img_big ?? "/newImg/preparing.png"}
                                                        className="coupon-image"
                                                        style={{ border: "1px solid #f9f9f9" }}
                                                    />

                                                    {coupon.uc_pin_status_cd !== '01' && (
                                                        <div
                                                            style={{
                                                                position: 'absolute',
                                                                top: '50%',
                                                                left: '50%',
                                                                transform: "translate(-50%, -50%)"
                                                            }}
                                                        >
                                                            <img
                                                                src={
                                                                    coupon.uc_pin_status_cd === '02'
                                                                        ? '/newImg/complete.png'
                                                                        : coupon.uc_pin_status_cd === '07'
                                                                            ? '/newImg/cancel.png'
                                                                            : coupon.uc_pin_status_cd === '08'
                                                                                ? '/newImg/expiration.png'
                                                                                : '/newImg/unavailable.png'
                                                                }
                                                                alt="used-type"
                                                                style={{ width: '85px' }}
                                                            />
                                                        </div>
                                                    )}
                                                    {coupon.uc_pin_status_cd !== '01' && (
                                                        <div
                                                            style={{
                                                                position: 'absolute',
                                                                top: '5px',
                                                                right: '5px',
                                                                border: "1px solid #e3e3e3",
                                                                width: "30px",
                                                                height: "30px",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                borderRadius: "5px",
                                                                boxShadow: "0 1px 5px rgba(0, 0, 0, 0.1)",
                                                                background: "#fff"
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleDelete(coupon.no);
                                                            }}
                                                        >
                                                            <Trash2 style={{ width: '22px', height: '22px' }} />
                                                        </div>
                                                    )}
                                                </div>

                                                <div className="coupon-info">
                                                    <div className="coupon-company table-overflow-hidden">
                                                        {coupon.ci_brand_name}
                                                    </div>
                                                    <div className="coupon-title table-overflow-hidden">
                                                        {coupon.ci_goods_name}
                                                    </div>
                                                    <div className="coupon-from table-overflow-hidden">
                                                        from. {Number(coupon.event_no) > 0 ? t('coupons_48') : coupon.is_gift > 0 ? coupon.purchaser_name : t('coupons_49')}
                                                    </div>
                                                    <div className="coupon-date table-overflow-hidden">
                                                        {formatUTCDateTime(coupon.uc_exchange_time)}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div ref={observerUsedRef} style={{ height: '1px' }}></div>
                                </>
                                :
                                <div style={{ width: "100%", margin: "30px 0", height: "260px", display:"flex", alignItems:"center", justifyContent:"center", flexDirection:"column" }}>
                                    <img src={`/img/noItem.png`} style={{ width: "150px", margin: "0 auto 10px" }} />
                                    <div style={{ width: "100%", textAlign: "center", fontSize: "18px", fontWeight: "bold", color: "#000", marginBottom: '5px' }}>{t('coupons_22')}</div>
                                    <div style={{ width: "100%", textAlign: "center", fontSize: "12px", fontWeight: "500", color: "gray" }}>{t('coupons_23')}</div>
                                </div>
                }
                <Coupons_Footer />
            </div>
        </div >
    );
}

export default Coupons;